import { render, staticRenderFns } from "./link-university-email-dialog.vue?vue&type=template&id=34edb865&scoped=true"
import script from "./link-university-email-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./link-university-email-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./link-university-email-dialog.vue?vue&type=style&index=0&id=34edb865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edb865",
  null
  
)

export default component.exports